<template>
  <div>
    <div
      class="mb-2 px-3"
      v-for="(item, index) in listPentest"
      :key="index"
      :style="{
        'border-bottom':
          listPentest.length != index + 1 ? '3px solid #d8d8d85c' : '',
      }"
    >
      <div class="d-column flex-row">
        <div class="no mt-3 d-flex flex-column pb-3 align-items-start">
          <div
            class="d-flex align-self-start d-flex flex-row align-items-start justify-content-start w-100"
          >
            <div class="d-flex w-100">
              <div class="align-self-start mt-1 w-100">
                <div class="card-chart-body w-100">
                  <div class="row">
                    <div class="col border-r-d mb-2">
                      <span class="pb-1">Tipo</span>
                      <h6
                        class="d-flex align-items-center justify-content-between"
                      >
                        <a>{{ $ml.get(item.type) }}</a>
                        <svg
                          v-if="item.type == 'whitebox'"
                          width="24"
                          height="24"
                          class="ico-view-report"
                        >
                          <image
                            xlink:href="../assets/icons/whitebox.png"
                            width="24"
                            height="24"
                          />
                        </svg>
                        <svg
                          v-else
                          width="24"
                          height="24"
                          class="ico-view-report"
                        >
                          <image
                            xlink:href="../assets/icons/blackbox.png"
                            width="24"
                            height="24"
                          />
                        </svg>
                      </h6>
                    </div>
                    <div class="col border-r-d pl-3 mb-2">
                      <span class="pb-1" v-text="$ml.get('applicationLocation')"
                        >Local da Aplicação</span
                      >
                      <h6>
                        <a v-if="item.applicationLocation === 'in_person'">{{
                          $ml.get("inPerson")
                        }}</a>
                        <a v-else>{{ $ml.get("remote") }}</a>
                      </h6>
                    </div>
                    <!-- <div class="col-3 border-r-d pl-3 mb-2">
                      <span class="pb-1" v-text="$ml.get('scope')">Escopo</span>
                      <h6>
                        <a>{{ $ml.get(item.scopes[0]) }}</a>
                      </h6>
                    </div> -->
                    <div class="col border-r pl-3 mb-2">
                      <div class="d-block">
                        <span class="pb-1 d-block" v-text="$ml.get('periodTh')"
                          >Período</span
                        >
                      </div>
                      <p class="p-0 m-0" style="font-weight: 400">
                        {{ $ml.get("startDate") }}:
                        {{ $utils.formatDataShort(item.initialDate) }}
                      </p>
                      <p class="p-0 m-0" style="font-weight: 400">
                        {{ $ml.get("endDate") }}:
                        {{ $utils.formatDataShort(item.finalDate) }}
                      </p>
                    </div>
                    <div class="col pl-3 mb-2">
                      <span class="pb-1 d-block" v-text="$ml.get('status')"
                        >Status</span
                      >
                      <div>
                        <a
                          class="badge badge-warning text-white"
                          v-if="item.status == 'pending'"
                          v-text="$ml.get('pending')"
                          >Pendente</a
                        >
                        <a
                          class="badge badge-warning text-white"
                          v-if="item.status == 'review'"
                          v-text="$ml.get('under_review')"
                          >Em revisão</a
                        >
                        <a
                          class="badge badge-success text-white"
                          v-show="item.status == 'in_progress'"
                          v-text="$ml.get('inProgress')"
                          >Em progresso</a
                        >
                        <a
                          class="badge badge-success text-white"
                          v-show="item.status == 'done'"
                          v-text="$ml.get('finished')"
                          >Finalizado</a
                        >
                        <a
                          class="badge badge-success text-white"
                          v-show="item.status == 'approved'"
                          v-text="$ml.get('approved')"
                          >Aprovado</a
                        >
                        <a
                          class="badge badge-danger text-white"
                          v-show="item.status == 'canceled'"
                          v-text="$ml.get('situationCancel')"
                          >Cancelado</a
                        >
                      </div>
                    </div>
                    <div
                      class="d-flex col-2 justify-content-end align-items-center"
                      style="gap: 10px"
                    >
                      <div
                        v-show="item.status === 'review' && item.message"
                        @click="item.show_message = !item.show_message"
                      >
                        <span class="pb-1"></span>
                        <VueCustomTooltip
                          :label="$ml.get('tooltipViewRejectedMessage')"
                        >
                          <svg width="24" height="24" class="">
                            <image
                              xlink:href="../assets/icons/message-fill.svg"
                              width="24"
                              height="24"
                            />
                          </svg>
                        </VueCustomTooltip>
                      </div>
                      <div
                        @click="
                          $router.push({
                            name: 'pentestDetail',
                            query: { id: item.id },
                          })
                        "
                      >
                        <span class="pb-1" style="margin-bottom: -2px"></span>
                        <VueCustomTooltip :label="$ml.get('viewPentest')">
                          <svg width="24" height="24">
                            <image
                              xlink:href="../assets/icons/eye.svg"
                              width="24"
                              height="24"
                            />
                          </svg>
                        </VueCustomTooltip>
                      </div>
                      <a v-if="item.file" :href="item.file" target="_blank">
                        <VueCustomTooltip label="Download">
                          <svg width="18" height="18">
                            <image
                              xlink:href="../assets/icons/download.svg"
                              width="18"
                              height="18"
                            />
                          </svg>
                        </VueCustomTooltip>
                      </a>
                      <div
                        v-if="item.status === 'pending'"
                        @click="deletePentest(item.id)"
                      >
                        <VueCustomTooltip :label="$ml.get('removeDomain')">
                          <svg width="22" height="22" class="">
                            <image
                              xlink:href="../assets/icons/remove-fill.svg"
                              width="22"
                              height="22"
                            />
                          </svg>
                        </VueCustomTooltip>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="alert alert-warning mb-0 mt-2"
                  v-show="item.show_message && item.message"
                >
                  <p v-html="$utils.convertMarkedOld(item.message)"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import pentestService from "../services/pentest.service";

export default {
  name: "listPentest",
  props: ["listPentest"],

  methods: {
    deletePentest(id) {
      var self = this;

      Swal.fire({
        heightAuto: false,
        text: self.$ml.get("areYouSureYouWantToDeleteThisPentest"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#730ba9",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          pentestService.deletePentest(id).then(
            () => {
              Swal.fire({
                icon: "success",
                title: self.$ml.get("swalDeletedPentest"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });

              self.$emit("updateList");
            },
            (error) => {
              console.log(error);
              Swal.fire({
                icon: "warning",
                title: self.$ml.get("unableToCompleteThisRequest"),
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
            },
          );
        }
      });
    },
  },
};
</script>
